<div class="d-flex align-items-center gap-2 flex-wrap mb-3">
  <button
    class="btn btn-primary btn-lg flex-grow-1 flex-xl-grow-0"
    (click)="addNewSchedule()"
  >
    <span> +Add New</span>
  </button>

  <ng-template *ngTemplateOutlet="siteClientLookup"></ng-template>
  @if (passedIdInRoute) {
    <button class="btn btn-outline-danger btn-lg" (click)="resetFilter(true)">
      Reset Filter
    </button>
  }
</div>

@if (selectedClient?.id || selectedSite?.id || passedIdInRoute) {
  <gtapp-gt-custom-table
    [deskTopTableData]="
      scheduledReportsPaginationData[pageNumScheduledReports] || []
    "
    [desktopTableDetails]="scheduledReportsColumns"
    [tableStyle]="tableStyle"
    [otherParams]="otherParamsScheduledReport"
    (sortColumn)="sortColumnScheduledReport($event)"
    (searchColumn)="searchColumnScheduledReport($event)"
    (rowClick)="
      onItemSelect($event, largeView ? null : reportExtraDetailsTemplate)
    "
    (paginationChange)="onChangePaginationScheduledReport($event)"
  ></gtapp-gt-custom-table>
}
@if (largeView) {
  <div class="pt-2">
    <ng-template [ngTemplateOutlet]="reportExtraDetailsTemplate"></ng-template>
  </div>
}

<ng-template
  #reportExtraDetailsTemplate
  let-data
  let-reportExtraDetailsTemplateRef="dialogRef"
>
  <div [ngClass]="data?.item_id ? 'dialog-box card' : ''">
    @if (data?.item_id) {
      <div class="card-header">
        <span class="float-end" (click)="reportExtraDetailsTemplateRef.close()">
          <i class="fa-solid fa-xmark"></i>
        </span>
      </div>
    }

    @if (selectedScheduledReportData?.id) {
      <div
        class="d-flex flex-wrap column-gap-4 row-gap-3 px-lg-4 flex-direction"
      >
        @if (!selectedScheduledReportData?.site_uuid) {
          <div class="col-12">
            <dl>
              <dt>Description</dt>
              <dd>
                This schedule will include reports for all sites belonging to
                this client.
              </dd>
            </dl>
          </div>
        }

        <dl>
          <dt>Time of Day</dt>
          <div
            class="link-edit fs-3 pe-2"
            (click)="
              openTemplate(updateScheduleTemplate, { source: 'mail_time' })
            "
          >
            {{ selectedScheduledReportData?.report_time }}
          </div>
        </dl>
        @if (data?.item_id) {
          @if (selectedScheduledReportData?.site_uuid) {
            <dl>
              <dt>Site</dt>
              <dd>
                {{ selectedScheduledReportData?.site_name }} [{{
                  selectedScheduledReportData?.company_name
                }}]
                <div class="small-font">
                  {{ selectedScheduledReportData?.site_address }}
                </div>
              </dd>
            </dl>
          } @else {
            <dl>
              <dt>Client</dt>
              <dd class="fs-5">
                {{ selectedScheduledReportData?.company_name }}
              </dd>
            </dl>
          }
        }

        <dl>
          <dt>
            Recipients
            <span class="fw-semibold"
              >[{{ selectedScheduledReportData?.contacts?.length }}]</span
            >
          </dt>

          <dd class="my-2 overflow-45vh">
            @for (
              contact of selectedScheduledReportData?.contacts;
              track contact;
              let i = $index
            ) {
              <div class="d-flex flex-column flex-wrap border rounded p-2 mb-2">
                <div class="min-width">
                  <div class="d-flex justify-content-between">
                    <div class="fw-semibold mb-2">
                      {{ contact?.first_name }} {{ contact?.last_name }}
                    </div>
                    @if (selectedScheduledReportData?.contacts?.length > 1) {
                      <div (click)="deleteContact(contact?.id)">
                        <i class="fa-solid fa-circle-minus fs-5 text-danger">
                        </i>
                      </div>
                    }
                  </div>
                  <div class="d-flex mb-2 align-items-center">
                    <i class="fa-solid fa-envelope text-primary"></i
                    ><a
                      class="text-decoration-none text-body ms-2"
                      href="mailto:{{ contact?.email }}"
                      >{{ contact?.email }}</a
                    >
                  </div>
                  @if (contact?.mobile_number) {
                    <div class="d-flex mb-2 align-items-center">
                      <i class="fa-solid fa-phone text-success"></i>
                      <a
                        class="text-decoration-none text-body ms-2"
                        href="tel:+{{ contact?.mobile_number }}"
                        >{{ contact?.mobile_number }}</a
                      >
                    </div>
                  }
                </div>
              </div>
            }
            <div
              class="rounded border p-2 mb-2 text-center hover"
              role="button"
              (click)="
                openTemplate(contactTemplate, {
                  source: 'contacts',
                  id: selectedScheduledReportData?.id,
                })
              "
            >
              <i class="fa-solid fa-plus"></i>
            </div>
          </dd>
        </dl>
        @if (selectedScheduledReportData?.jobs?.length) {
          <dl>
            <dt>
              Send Queue
              <span class="fw-semibold"
                >[{{ selectedScheduledReportData?.jobs?.length }}]</span
              >
            </dt>
            <div class="input-group">
              <div class="form-floating">
                <input
                  type="text"
                  [(ngModel)]="selectedScheduledReportData.searchStr"
                  placeholder="Filter Events"
                  class="form-control"
                  (input)="filterJobs()"
                />
                <label>Search</label>
              </div>
              @if (selectedScheduledReportData?.searchStr) {
                <span
                  class="input-group-text"
                  (click)="
                    selectedScheduledReportData.searchStr = ''; filterJobs()
                  "
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>

            <dd class="my-2 overflow-45vh">
              @for (
                job of selectedScheduledReportData?.searchStr
                  ? selectedScheduledReportData?.filteredJobList
                  : selectedScheduledReportData?.jobs;
                track job;
                let i = $index
              ) {
                <div
                  class="d-flex flex-column flex-wrap border rounded p-2 mb-2"
                >
                  <div class="min-width d-flex gap-2">
                    <div
                      class="flex-grow-1"
                      [class.opacity-50]="
                        selectedScheduledReportData?.additional_info?.excluded_job_ids?.includes(
                          job?.id
                        )
                      "
                    >
                      <div>
                        {{ job?.job_key }}
                      </div>
                      <div class="small text-secondary">
                        {{ job?.status }}
                      </div>
                      <div class="fw-semibold">
                        {{ job?.job_type }}
                      </div>
                    </div>
                    <div class="d-flex flex-column gap-3">
                      <div (click)="redirectToJob(job)">
                        <i
                          class="fa-solid fa-file-invoice fs-3 text-primary"
                        ></i>
                      </div>
                      @if (
                        selectedScheduledReportData?.additional_info?.excluded_job_ids?.includes(
                          job?.id
                        )
                      ) {
                      } @else {
                        <div (click)="addRemoveJob(job, true)">
                          <i
                            class="fa-solid fa-circle-minus fs-4 text-danger"
                          ></i>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </dd>
          </dl>
        } @else {
          <div class="ms-lg-1 mx-auto fw-semibold mb-3">
            No reports currently queued
          </div>
        }

        <div class="mx-auto">
          <button class="btn btn-md btn-danger" (click)="deleteSchedule()">
            Delete Schedule
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #contactTemplate let-contactTemplateRef="dialogRef" let-data>
  <div class="card dialog-box">
    <div class="card-header">
      Add Contacts
      <span class="float-end" (click)="contactTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="mb-2">
        <gtapp-auto-complete
          [data]="contactListData"
          placeHolder="Select Contact"
          searchKeyword="full_name"
          [itemTemplate]="contactLookupTemplate"
          (inputChanged)="onContactSearch($event)"
          (selected)="contactForm.patchValue($event)"
          [enableCloseOption]="true"
        >
        </gtapp-auto-complete>
        <ng-template #contactLookupTemplate let-item>
          <div>
            <div class="fw-medium">
              {{ item?.first_name }} {{ item?.last_name }}
            </div>

            <div class="small-font text-secondary">
              {{ item?.email }}
            </div>
          </div>
        </ng-template>
      </div>
      <div class="border rounded p-2">
        <div class="mb-2 fw-semibold small">New Contact</div>

        <div class="p-3">
          <form [formGroup]="contactForm" appFormEnterAction>
            <div class="row row-cols-1 g-2 mb-4">
              <div class="form-floating">
                <input
                  class="form-control"
                  type="text"
                  id="firstName"
                  (keyup.enter)="shiftFocus('lastName')"
                  formControlName="first_name"
                  autocomplete="off"
                  [maxlength]="150"
                  placeholder="First Name"
                />
                <label for="firstName">First Name</label>
              </div>

              <div class="form-floating">
                <input
                  class="form-control"
                  type="text"
                  id="lastName"
                  (keyup.enter)="shiftFocus('email')"
                  formControlName="last_name"
                  autocomplete="off"
                  [maxlength]="150"
                  placeholder="Last Name"
                />
                <label for="lastName">Last Name</label>
              </div>

              <div class="form-floating">
                <input
                  class="form-control"
                  type="email"
                  id="email"
                  [class.is-invalid]="
                    contactForm.controls['email'].invalid &&
                    contactForm.controls['email'].touched
                  "
                  (keyup.enter)="shiftFocus('phone')"
                  formControlName="email"
                  autocomplete="off"
                  placeholder="Email"
                />
                <label for="email">Email</label>
              </div>
              @if (dupContactCheck()) {
                <div>
                  <p class="text-danger">Email address already added</p>
                </div>
              }

              <div class="form-floating">
                <input
                  class="form-control"
                  type="tel"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  minlength="7"
                  maxlength="10"
                  id="phone"
                  formControlName="mobile_number"
                  autocomplete="off"
                  placeholder="Telephone (Optional)"
                  (input)="mobileNumberCheck()"
                />
                <label for="phone">Telephone (Optional)</label>
                @if (
                  contactForm.controls["mobile_number"].invalid &&
                  contactForm.controls["mobile_number"].touched
                ) {
                  <div>
                    <p class="text-danger">
                      Mobile should be a 10-digit number
                    </p>
                  </div>
                }
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="row g-2 my-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-darkn-light w-100"
            (click)="contactForm.reset(); contactTemplateRef.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-primary w-100"
            [disabled]="!contactForm.valid || dupContactCheck()"
            (click)="contactTemplateRef.close(contactForm.value)"
          >
            Add Contact
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #updateScheduleTemplate
  let-data
  let-updateScheduleTemplateRef="dialogRef"
>
  <div class="card dialog-box">
    <div class="card-header">
      <span class="float-end" (click)="updateScheduleTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    @switch (data?.source) {
      @case ("mail_time") {
        <div class="form-floating">
          <input
            class="form-control"
            type="time"
            placeholder="Send Report At"
            (change)="roundDateTimeToQuarterHour($event)"
            [ngModel]="newReportData?.mail_time"
          />
          <label>Send Report At</label>
        </div>
      }
    }
    <div class="d-flex gap-2 pt-3">
      <button
        type="button"
        class="btn btn-success btn-lg w-100"
        [disabled]="!newReportData?.[data?.source]"
        (click)="updateReport(data?.source); updateScheduleTemplateRef.close()"
      >
        Submit
      </button>
    </div>
  </div>
</ng-template>

<!-- <div class="mt-1 mx-1">
  <div class="fixed-add-btn">
    <button class="btn btn-primary btn-lg w-100" (click)="addNewSchedule()">
      <span><i class="fa-solid fa-plus"></i></span>
    </button>
  </div>
</div> -->

<ng-template #siteClientLookup let-siteClientLookupTempRef="dialogRef">
  <div class="flex-grow-1 flex-xl-grow-0">
    @if (selectedClient?.id) {
      <div>
        <dl class="px-2 px-md-4">
          <dt>Client</dt>
          <dd (click)="editField('client')" class="link-edit">
            {{ selectedClient?.company_name }}
          </dd>
        </dl>
      </div>
    } @else {
      <div>
        <gtapp-auto-complete
          [data]="clientDropDownList"
          placeHolder="Select Client"
          searchKeyword="company_name"
          [itemTemplate]="clientTemplate"
          (inputChanged)="onClientSearch($event)"
          [initialValue]="selectedClient?.company_name"
          (selected)="onClientSelect($event)"
          [enableCloseOption]="true"
          inputId="clientLookupId"
          (fieldCleared)="editField('client')"
          (inputFocused)="inputFocused('client')"
        >
        </gtapp-auto-complete>

        <ng-template #clientTemplate let-item>
          <div>
            {{ item?.company_name }}
          </div>
        </ng-template>
      </div>
    }
  </div>
  @if (selectedClient?.id) {
    <div class="flex-grow-1 flex-xl-grow-0">
      @if (selectedSite?.id) {
        <div>
          <dl class="px-2 px-md-4">
            <dt>Site</dt>
            <dd (click)="editField('site')" class="link-edit">
              {{ selectedSite?.company_name }}
            </dd>
          </dl>
        </div>
      } @else {
        <div>
          <gtapp-auto-complete
            [data]="siteListData"
            placeHolder="Select Site"
            searchKeyword="company_name"
            [initialValue]="selectedSite?.company_name"
            [itemTemplate]="siteTemplate"
            (inputChanged)="onSiteSearch($event)"
            (selected)="onSelectSite($event)"
            inputId="siteId"
            [enableCloseOption]="true"
            (fieldCleared)="editField('site')"
            (inputFocused)="inputFocused('site')"
          >
          </gtapp-auto-complete>

          <ng-template #siteTemplate let-item>
            <div>
              <div class="fw-medium">
                {{ item?.company_name }}
              </div>
              <div class="small-font text-secondary">
                {{ item?.address?.full_address }}
              </div>
            </div>
          </ng-template>
        </div>
      }
    </div>
  }
</ng-template>
